<!--new summary-->


<!--VISTA DESCRIPCION DEL CURSO INTERNO - INSTANCE -->
<!--PARTE 2 DESCRIPCION --- COMPONENTE  -->

<div class="mx-auto max-w-7xl w-full md:py-8  flex flex-col lg:flex-row gap-8" *ngIf="instance">

    <!-- DESCRIPCION -->
    <div class="flex-1 min-w-0">
        <div style="display: none;" class="hidden inline-flex bg-muted rounded-full p-1 mb-8">
            <button
                class="px-6 py-2 rounded-full text-sm font-medium transition-all bg-white text-gray-700 shadow-sm">Presentación</button>
            <button
                class="px-6 py-2 rounded-full text-sm font-medium transition-all text-muted-foreground hover:text-gray-700">Resumen</button>
        </div>

        <div class="mb-8 bg-white md:
        border md:border-border/60 md:rounded-lg p-6 shadow-sm">
            <h2 class="text-lg font-semibold text-gray-700 mb-3 inline-block relative group">
                Descripción
                <span
                    class="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-secondary transition-all duration-300 ease-out group-hover:w-full"></span>
            </h2>
            <div class="journey-description-summary">
                <p readMore #readMoreEl="readMore" class="inner-html"
                    [innerHTML]="instance?.description ? (instance.description | safe:'html') : ('words.undescribed-content' | translate)">
                </p>
            </div>
            <a class="text-gray-400 text-sm cursor-pointer" *ngIf="readMoreEl.overflow"
                (click)="readMoreEl.toggleExtend()">{{
                'words.read-more.' +
                readMoreEl.extended | translate }} <span> <i class="icon text-xs"
                        [class.icon-arrow-ios-up]="readMoreEl.extended"
                        [class.icon-arrow-ios-down]="!readMoreEl.extended"></i></span></a>

        </div>

        <!-- INFORMACIÓN DEL CURSO -->
        <div class="mb-8"
            *ngIf="instance?.requirement || instance?.template?.requirement || instance?.target || instance?.template?.target || instance?.purpose || instance?.template?.purpose">
       

            <div class="mb-8 bg-white md:border md:border-border/60 md:rounded-lg p-6 shadow-sm space-y-4">
                     <h2 class="text-lg font-semibold text-gray-700 inline-block relative group">
                {{ 'words.course-info' | translate }}
                <span
                    class="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-secondary transition-all duration-300 ease-out group-hover:w-full"></span>
            </h2>
                <!-- Acordeón: Requisitos previos -->
                <div class="border border-gray-200 rounded-lg"
                    *ngIf="instance?.requirement || instance?.template?.requirement">
                    <button class="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
                        (click)="toggleAccordionItem('requirements')">
                        <span class="font-semibold text-gray-800">{{ 'studio.create.course.requirement' | translate }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="transition-transform duration-300"
                            [class.rotate-180]="accordionOpen['requirements']">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </button>
                    <div class="overflow-hidden transition-all duration-300"
                        [style.max-height]="accordionOpen['requirements'] ? '1000px' : '0'">
                        <div class="px-4 pb-4 bg-gray-50 border-t border-gray-200 inner-html text-gray-700 text-sm leading-relaxed"
                            [innerHTML]="(instance?.requirement ? instance?.requirement : instance?.template?.requirement) | safe:'html'"></div>
                    </div>
                </div>

                <!-- Acordeón: Audiencia -->
                <div class="border border-gray-200 rounded-lg"
                    *ngIf="instance?.target || instance?.template?.target">
                    <button class="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
                        (click)="toggleAccordionItem('audience')">
                        <span class="font-semibold text-gray-800">{{ 'studio.create.course.audience' | translate }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="transition-transform duration-300"
                            [class.rotate-180]="accordionOpen['audience']">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </button>
                    <div class="overflow-hidden transition-all duration-300"
                        [style.max-height]="accordionOpen['audience'] ? '1000px' : '0'">
                        <div class="px-4 pb-4 bg-gray-50 border-t border-gray-200 inner-html text-gray-700 text-sm leading-relaxed"
                            [innerHTML]="(instance?.target ? instance?.target : instance?.template?.target) | safe:'html'"></div>
                    </div>
                </div>

                <!-- Acordeón: Propósito -->
                <div class="border border-gray-200 rounded-lg"
                    *ngIf="instance?.purpose || instance?.template?.purpose">
                    <button class="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
                        (click)="toggleAccordionItem('purpose')">
                        <span class="font-semibold text-gray-800">{{ 'studio.create.course.purpose' | translate }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="transition-transform duration-300"
                            [class.rotate-180]="accordionOpen['purpose']">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </button>
                    <div class="overflow-hidden transition-all duration-300"
                        [style.max-height]="accordionOpen['purpose'] ? '1000px' : '0'">
                        <div class="px-4 pb-4 bg-gray-50 border-t border-gray-200 inner-html text-gray-700 text-sm leading-relaxed"
                            [innerHTML]="(instance?.purpose ? instance?.purpose : instance?.template?.purpose) | safe:'html'"></div>
                    </div>
                </div>
            </div>
        </div>


        <!-- LECCIONES — solo si está suscrito -->
        <ng-container>

            <div class="mx-4 md:mx-0 flex items-center justify-between mb-5">
                <h3 class="text-lg font-semibold text-gray-700 flex items-center gap-2.5">
                    <div class="w-1.5 h-6 rounded-full bg-secondary"></div>{{'words.lessons' | translate}}
                </h3>
                <div
                    class="flex items-center gap-1.5 text-xs font-medium text-gray-700 bg-gray-100 px-3 py-1.5 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="w-4 h-4">
                        <path
                            d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z">
                        </path>
                        <path d="M15 5.764v15"></path>
                        <path d="M9 3.236v15"></path>
                    </svg>
                    <span>{{ getTotalLessons() }} {{'words.lessons' | translate}} {{'words.in-total' | translate }}</span>
                </div>
            </div>
            <!-- LECCIONES MOBILE — acordeón solo en teléfono -->
            <div class="lessons-mobile-accordion mx-4 flex flex-col gap-2" *ngIf="summary && summary.length > 0">
                <div *ngFor="let section of summary; let i = index"
                    class="rounded-lg border border-border/60 bg-white overflow-hidden">
                    <!-- Acordeón header -->
                    <button type="button"
                        class="w-full flex items-center gap-3 p-4 text-left transition-colors"
                        [ngClass]="openSections[i] ? 'bg-secondary-50' : 'bg-white hover:bg-gray-50'"
                        (click)="openSections[i] = !openSections[i]">
                        <div class="shrink-0 w-8 h-8 rounded-md flex items-center justify-center"
                            [ngClass]="openSections[i] ? 'bg-secondary-200' : 'bg-muted'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                [ngClass]="openSections[i] ? 'w-4 h-4 text-secondary' : 'w-4 h-4 text-muted-foreground'">
                                <path d="M2 6h4"></path>
                                <path d="M2 10h4"></path>
                                <path d="M2 14h4"></path>
                                <path d="M2 18h4"></path>
                                <rect width="16" height="20" x="4" y="2" rx="2"></rect>
                                <path d="M9.5 8h5"></path>
                                <path d="M9.5 12H16"></path>
                                <path d="M9.5 16H14"></path>
                            </svg>
                        </div>
                        <div class="flex-1 min-w-0">
                            <p class="text-sm font-semibold leading-snug"
                                [ngClass]="openSections[i] ? 'text-secondary-500' : 'text-gray-700'">
                                {{ section.title || ('words.untitled' | translate) }}
                            </p>
                            <p class="text-[11px] text-gray-500 mt-0.5">
                                {{ section.sectionContents?.length || 0 }} {{'words.lessons' | translate}}
                            </p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"
                            class="w-4 h-4 shrink-0 text-gray-400 transition-transform duration-300"
                            [ngClass]="openSections[i] ? 'rotate-180' : ''">
                            <path d="m6 9 6 6 6-6" />
                        </svg>
                    </button>
                    <!-- Acordeón contenido -->
                    <div *ngIf="openSections[i]" class="border-t border-border/60 p-3 flex flex-col gap-2">
                        <ng-container *ngIf="section.sectionContents && section.sectionContents.length > 0; else noActivitiesMobile">
                            <button *ngFor="let activity of section.sectionContents"
                                (click)="subscribed && redirectActivityToPlayer(section, activity)"
                                class="w-full text-left flex items-center gap-3 p-3 rounded-xl border border-border/60 bg-white transition-all"
                                [ngClass]="subscribed ? 'hover:bg-white hover:shadow-md cursor-pointer' : 'cursor-default opacity-80'">
                                <div class="w-10 h-10 rounded-md bg-muted flex items-center justify-center shrink-0">
                                    <i class="icon text-base text-gray-500"
                                        [ngClass]="getActivityIcon(activity.context)"></i>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <h5 class="text-sm font-semibold text-gray-700">{{ activity.title ||
                                        ('words.untitled' | translate) }}</h5>
                                </div>
                                <ng-container *ngIf="subscribed; else activityLockedMobileTpl">
                                    <div class="relative shrink-0 w-12 h-12">
                                        <svg class="w-full h-full -rotate-90" viewBox="0 0 44 44">
                                            <defs>
                                                <linearGradient id="ring-grad-mob" x1="0%" y1="0%" x2="100%" y2="0%">
                                                    <stop offset="0%" style="stop-color: var(--v2-color-primary-500)" />
                                                    <stop offset="80%" style="stop-color: var(--v2-color-primary-500)" />
                                                    <stop offset="100%" style="stop-color: var(--v2-color-primary-500)" />
                                                </linearGradient>
                                            </defs>
                                            <circle cx="22" cy="22" r="18" stroke="#e5e7eb" stroke-width="4" fill="none" />
                                            <circle cx="22" cy="22" r="18" stroke="url(#ring-grad-mob)"
                                                stroke-width="4" fill="none" stroke-linecap="round"
                                                [attr.stroke-dasharray]="113.1"
                                                [attr.stroke-dashoffset]="113.1 - ( (activity?.progress || 0) * 113.1 / 100 )"
                                                class="transition-all duration-300 ease-in-out" />
                                        </svg>
                                        <div class="absolute inset-0 flex items-center justify-center">
                                            <span class="text-[10px] font-bold leading-none text-gray-700">
                                                {{ activity?.progress || 0 }}%
                                            </span>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #activityLockedMobileTpl>
                                    <i class="icon icon-lock text-gray-400 text-xl shrink-0"></i>
                                </ng-template>
                            </button>
                        </ng-container>
                        <ng-template #noActivitiesMobile>
                            <p class="text-sm text-gray-500 text-center py-4">{{'words.empty' | translate}}</p>
                        </ng-template>
                    </div>
                </div>
            </div>

            <!-- LECCIONES DESKTOP  -->
            <div class="hidden md:grid gap-4 transition-all duration-700 ease-in-out"
                [ngClass]="sidebarCollapsed ? 'grid-cols-[auto_1fr]' : 'grid-cols-[300px_1fr]'"
                *ngIf="summary && summary.length > 0">
                <div class="flex flex-col gap-2 rounded-lg transition-all duration-700 ease-in-out" style="background-color: #f8f8f8;"
                    [ngClass]="sidebarCollapsed ? 'w-14 py-2 items-center' : 'w-auto p-4'">
                    <!-- Header sidebar -->
                    <div class="flex items-center justify-between gap-2 mb-1"
                        [ngClass]="sidebarCollapsed ? 'justify-center' : ''">
                        <h3 class="text-sm font-semibold text-gray-600 truncate" *ngIf="!sidebarCollapsed">
                            {{'words.course-content' | translate}}
                        </h3>
                        <button type="button"
                            class="flex items-center justify-center w-7 h-7 shrink-0 rounded-full border border-border bg-transparent hover:bg-muted/40 transition-all duration-300 text-gray-500"
                            [attr.aria-label]="sidebarCollapsed ? 'Expandir módulos' : 'Colapsar módulos'"
                            [title]="sidebarCollapsed ? 'Expandir' : 'Colapsar'"
                            (click)="sidebarCollapsed = !sidebarCollapsed">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="w-4 h-4 transition-transform duration-700 ease-in-out"
                                [ngClass]="sidebarCollapsed ? 'rotate-180' : ''">
                                <path d="m15 18-6-6 6-6" />
                            </svg>
                        </button>
                    </div>
                    <!-- Section buttons -->
                    <button *ngFor="let section of summary; let i = index" (click)="selectedSectionIndex = i"
                        class="flex items-start gap-2.5 text-left  rounded-md border transition-all duration-500 ease-in-out"
                        [title]="sidebarCollapsed ? (section.title || ('words.untitled' | translate)) : ''" [ngClass]="{
                            'bg-secondary-100 border-secondary-300 text-secondary-500 shadow-sm': selectedSectionIndex === i,
                            'bg-white border-border/60 hover:bg-white hover:shadow-md': selectedSectionIndex !== i,
                            'justify-center p-1': sidebarCollapsed,
                            'p-3': !sidebarCollapsed
                        }">
                        <div class="shrink-0 w-9 h-9 rounded-md flex items-center justify-center"
                            [ngClass]="selectedSectionIndex === i ? 'bg-secondary-200' : 'bg-muted'">
                            <svg *ngIf="selectedSectionIndex === i" xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 text-secondary">
                                <path
                                    d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z">
                                </path>
                                <path d="M20 3v4"></path>
                                <path d="M22 5h-4"></path>
                                <path d="M4 17v2"></path>
                                <path d="M5 18H3"></path>
                            </svg>
                            <svg *ngIf="selectedSectionIndex !== i" xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 text-muted-foreground">
                                <path d="M2 6h4"></path>
                                <path d="M2 10h4"></path>
                                <path d="M2 14h4"></path>
                                <path d="M2 18h4"></path>
                                <rect width="16" height="20" x="4" y="2" rx="2"></rect>
                                <path d="M9.5 8h5"></path>
                                <path d="M9.5 12H16"></path>
                                <path d="M9.5 16H14"></path>
                            </svg>
                        </div>
                        <div class="min-w-0 flex-1" *ngIf="!sidebarCollapsed">
                            <p class="text-sm  font-semibold leading-snug"
                                [ngClass]="selectedSectionIndex === i ? 'text-secondary-500' : 'text-gray-700'">
                                {{ section.title || ('words.untitled' | translate) }}
                            </p>
                            <p class="text-[11px] text-gray-500 mt-0.5">
                                {{ section.sectionContents?.length || 0 }} {{'words.lessons' | translate}}
                            </p>
                        </div>
                    </button>
                </div>

                <div class="flex flex-col gap-4 md:self-start md:sticky md:top-24 md:max-h-[calc(100vh-7rem)] md:overflow-y-auto"
                    *ngIf="summary[selectedSectionIndex] as activeSection">
                    <div class="rounded-lg border border-border/60 bg-white p-4">
                        <div class="flex items-start justify-between gap-3 mb-4">
                            <div class="min-w-0 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="w-5 h-5 text-muted-foreground/70">
                                    <path d="M2 6h4"></path>
                                    <path d="M2 10h4"></path>
                                    <path d="M2 14h4"></path>
                                    <path d="M2 18h4"></path>
                                    <rect width="16" height="20" x="4" y="2" rx="2"></rect>
                                </svg>
                                <h4 class="text-base font-bold text-gray-700">{{ activeSection.title ||
                                    ('words.untitled' | translate) }}</h4>
                            </div>
                        </div>
                        <ng-container
                            *ngIf="activeSection.sectionContents && activeSection.sectionContents.length > 0; else noActivities">
                            <button *ngFor="let activity of activeSection.sectionContents"
                                (click)="subscribed && redirectActivityToPlayer(activeSection, activity)"
                                class="w-full text-left flex items-center gap-3 p-3 rounded-xl border border-border/60 bg-white transition-all mb-2 last:mb-0"
                                [ngClass]="subscribed ? 'hover:bg-white hover:shadow-md cursor-pointer' : 'cursor-default opacity-80'">
                                <div class="w-10 h-10 rounded-md bg-muted flex items-center justify-center shrink-0">
                                    <i class="icon text-base text-gray-500"
                                        [ngClass]="getActivityIcon(activity.context)"></i>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <h5 class="text-sm font-semibold text-gray-700">{{ activity.title ||
                                        ('words.untitled' | translate) }}</h5>

                                </div>
                                <ng-container *ngIf="subscribed; else activityLockedTpl">
                                    <div class="relative shrink-0 w-12 h-12">
                                        <svg class="w-full h-full -rotate-90" viewBox="0 0 44 44">
                                            <defs>
                                                <!-- Definición del gradiente usando tus variables -->
                                                <linearGradient id="ring-grad-activity" x1="0%" y1="0%" x2="100%"
                                                    y2="0%">
                                                    <stop offset="0%" style="stop-color: var(--v2-color-primary-500)" />
                                                    <stop offset="80%"
                                                        style="stop-color: var(--v2-color-primary-500)" />
                                                    <stop offset="100%"
                                                        style="stop-color: var(--v2-color-primary-500)" />
                                                </linearGradient>
                                            </defs>

                                            <!-- Círculo de fondo (Gris) -->
                                            <circle cx="22" cy="22" r="18" stroke="#e5e7eb" stroke-width="4"
                                                fill="none" />

                                            <!-- Círculo de progreso (Dinámico) -->
                                            <!-- El stroke-dasharray de 113.1 corresponde a la circunferencia (2 * PI * 18) -->
                                            <circle cx="22" cy="22" r="18" stroke="url(#ring-grad-activity)"
                                                stroke-width="4" fill="none" stroke-linecap="round"
                                                [attr.stroke-dasharray]="113.1"
                                                [attr.stroke-dashoffset]="113.1 - ( (activity?.progress || 0) * 113.1 / 100 )"
                                                class="transition-all duration-300 ease-in-out" />
                                        </svg>

                                        <!-- Texto central -->
                                        <div class="absolute inset-0 flex items-center justify-center">
                                            <span class="text-[10px] font-bold leading-none text-gray-700">
                                                {{ activity?.progress || 0 }}%
                                            </span>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #activityLockedTpl>
                                    <i class="icon icon-lock text-gray-400 text-xl shrink-0"></i>
                                </ng-template>
                            </button>
                        </ng-container>
                        <ng-template #noActivities>
                            <p class="text-sm text-gray-500 text-center py-4">{{'words.empty' | translate}}</p>
                        </ng-template>
                    </div>
                </div>
            </div>

        </ng-container>

        <!-- Placeholder cuando NO está suscrito — MOBILE -->
        <div class="lessons-mobile-accordion flex flex-col gap-2 mt-2" *ngIf="!subscribed && summary && summary.length > 0">
            <div *ngFor="let section of summary; let i = index"
                class="rounded-lg border border-dashed border-border/60 bg-muted/30 overflow-hidden">
                <!-- Acordeón header -->
                <button type="button"
                    class="w-full flex items-center gap-3 p-4 text-left bg-transparent hover:bg-muted/40 transition-colors"
                    (click)="openSections[i] = !openSections[i]">
                    <div class="shrink-0 w-8 h-8 rounded-md flex items-center justify-center bg-muted">
                        <i class="icon icon-lock text-base text-muted-foreground"></i>
                    </div>
                    <div class="flex-1 min-w-0">
                        <p class="text-sm font-semibold text-gray-700">
                            {{ section.title || ('words.untitled' | translate) }}
                        </p>
                        <p class="text-[11px] text-gray-500 mt-0.5">
                            {{ section.sectionContents?.length || 0 }} {{'words.lessons' | translate}}
                        </p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"
                        class="w-4 h-4 shrink-0 text-gray-400 transition-transform duration-300"
                        [ngClass]="openSections[i] ? 'rotate-180' : ''">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </button>
                <!-- Acordeón contenido bloqueado -->
                <div *ngIf="openSections[i]" class="border-t border-border/60 p-3 flex flex-col gap-2">
                    <button *ngFor="let activity of section.sectionContents"
                        class="w-full text-left flex items-center gap-3 p-3 rounded-xl border border-border/60 bg-white cursor-default opacity-70">
                        <div class="w-10 h-10 rounded-md bg-muted flex items-center justify-center shrink-0">
                            <i class="icon text-base text-gray-500"
                                [ngClass]="getActivityIcon(activity.context)"></i>
                        </div>
                        <div class="flex-1 min-w-0">
                            <h5 class="text-sm font-semibold text-gray-700">{{ activity.title ||
                                ('words.untitled' | translate) }}</h5>
                        </div>
                        <i class="icon icon-lock text-gray-400 text-xl shrink-0"></i>
                    </button>
                    <div class="flex flex-col items-center justify-center gap-2 py-3">
                        <p class="text-xs text-muted-foreground text-center max-w-xs">{{ 'words.subscribe' | translate }}
                            {{'words.to' | translate | lowercase}} {{'words.access-content' | translate | lowercase}}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Placeholder cuando NO está suscrito -->
        <ng-template #notSubscribedLessons>
            <div
                class="flex flex-col items-center justify-center gap-3 py-12 rounded-2xl border border-dashed border-border/60 bg-muted/30">
                <div class="w-12 h-12 rounded-full bg-muted flex items-center justify-center">
                    <i class="icon icon-lock text-xl text-muted-foreground"></i>
                </div>
                <p class="text-sm font-semibold text-gray-700">{{'words.lessons' | translate}}</p>
                <p class="text-xs text-muted-foreground text-center max-w-xs">{{ 'words.subscribe' | translate }}
                    {{'words.to' | translate | lowercase}} {{'words.access-content' | translate | lowercase}}</p>
            </div>
        </ng-template>

    </div>
    <!-- CARD  -->
    <div class="w-full lg:w-[300px] shrink-0">
        <div class="bg-white rounded-lg border border-border/50 overflow-hidden shadow-md mx-4 md:mx-0 ">
            <div class="p-5 flex flex-col gap-3">
                <h4 class="text-lg font-bold text-gray-700">{{'words.course-details' | translate}}</h4>
                <hr class="border-gray-200" />
                <!-- Detalles duración e idioma -->
                <div class="flex flex-col gap-2.5 text-sm text-muted-foreground">
                    <div class="flex items-center gap-2.5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4 shrink-0">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        <span>{{ convertSecondsToHoursMinutes(instance?.duration) }} </span>
                    </div>
                    <div class="flex items-center gap-2.5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4 shrink-0">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                            <path d="M2 12h20"></path>
                        </svg>
                        <span>{{ instance?.language?.name }}</span>
                    </div>
                    <div class="flex items-center gap-2.5"
                        *ngIf="instance?.type && instance.type !== 'course_instance' && instance.type !== 'course_template' && instance.type !== 'external_content'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4 shrink-0">
                            <path d="M12 7v14"></path>
                            <path
                                d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z">
                            </path>
                        </svg>
                        <span>{{ 'type.' + instance.type | translate }}</span>
                    </div>
                </div>

                <!-- Botón iniciar / suscribirse según estado -->
                <div class="flex flex-col gap-2 mt-1">
                    <button *ngIf="subscribed" (click)="onPlayContent.emit()"
                        [disabled]="instance?.subscriptionState == 'pending' || instance?.subscriptionState == 'refused'"
                        class="w-full py-2.5 rounded-full text-sm font-semibold bg-primary text-white hover:bg-secondary-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                        {{'words.resume-course' | translate}}
                        <i class="fa-solid fa-arrow-right text-xs"></i>
                    </button>

                    <button *ngIf="!subscribed" (click)="onSubscribe.emit()" [disabled]="processing || !isLoaded"
                        class="w-full py-2.5 rounded-full text-sm font-semibold bg-primary text-white hover:bg-secondary-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                        {{'words.subscribe' | translate}}
                    </button>

                    <div *ngIf="instance?.subscriptionState === 'pending'"
                        class="flex items-center gap-2 text-xs text-blue-600">
                        <i class="icon icon-clock-1"></i>
                        <span>{{'words.subscription-pending' | translate}}</span>
                    </div>
                    <div *ngIf="instance?.subscriptionState === 'refused'"
                        class="flex items-center gap-2 text-xs text-red-500">
                        <i class="icon icon-slash"></i>
                        <span>{{'words.subscription-refused' | translate}}</span>
                    </div>

                    <button *ngIf="instance?.subscribed" (click)="onUnsubscribe.emit()"
                        class="w-full shadow-sm py-2 rounded-full hover:shadow-md text-sm text-gray-600 border border-gray-500 hover:bg-gray-200 transition-colors flex items-center justify-center gap-2 hover:text-gray-700">
                        {{ 'words.unsubscribe' | translate }}
                    </button>
                </div>


                <!-- Acciones secundarias -->
                <div class="w-full h-px bg-gray-200"></div>

                <div class="flex justify-around pt-1">
                    <button *ngIf="subscribed" (click)="onRate.emit()"
                        class="flex flex-col items-center gap-1 text-gray-400 hover:text-yellow-500 text-[10px] uppercase font-bold transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4 text-gray-500">
                            <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                            </path>
                        </svg>
                        <span class="text-gray-500 text-[10px] font-medium uppercase tracking-wide">{{'words.rate' | translate}}</span>
                    </button>
                    <div class="w-px bg-gray-200 mx-1" *ngIf="subscribed"></div>
                    <button [class.text-primary]="saved" [class.text-muted-foreground]="!saved" (click)="onSave.emit()"
                        class="flex flex-col items-center gap-1 text-muted-foreground hover:text-gray-700 transition-colors group">
                        <svg [class.icon-bookmark-1]="saved" [class.icon-bookmark]="!saved"
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4 text-gray-500">
                            <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"></path>
                        </svg>
                        <span class="text-gray-500 text-[10px] font-medium uppercase tracking-wide">{{ saved ? ('word-saved' | translate) : ('common.save' | translate) }}</span>
                    </button>
                    <div class="w-px bg-gray-200 mx-1" *ngIf="subscribed"></div>
                    <button (click)="onOpenConversation.emit()"
                        class="flex flex-col items-center gap-1 text-muted-foreground hover:text-gray-700 transition-colors group">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4 text-gray-500">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        <span class="text-gray-500 text-[10px] font-medium uppercase tracking-wide"> {{'words.support' | translate}}</span>
                    </button>
                </div>

            </div>
        </div>

        <!-- Producido por -->
        <div class="mx-4 md:mx-0 mt-4 bg-white rounded-lg border border-border/50 shadow-md p-4 flex items-center gap-3">
            <div
                class="w-12 h-12 rounded-full bg-white border border-border/60 shrink-0 overflow-hidden flex items-center justify-center">
                <img #instanceProviderImg *ngIf="getProviderLogoUrl()" [src]="getProviderLogoUrl()" alt="provider logo"
                    class="max-w-[80%] max-h-[80%] object-contain"
                    (error)="instanceProviderImg.style.display='none'; instanceProviderFallback.style.display='flex'">
                <span #instanceProviderFallback [style.display]="getProviderLogoUrl() ? 'none' : 'flex'"
                    class="text-sm font-bold text-muted-foreground">
                    {{ (instance?.provider?.name || company?.name || 'G').charAt(0).toUpperCase() }}
                </span>
            </div>
            <div class="min-w-0 flex flex-col">
                <span class="text-[10px] uppercase font-bold text-gray-700">{{'words.producted-by' |
                    translate}}</span>
                <h5 class="text-sm font-normal text-gray-500 truncate">{{ instance?.provider?.name || company?.name }}
                </h5>
            </div>
        </div>
    </div>
</div>


